import StaffRoleUsersPage from "./StaffRoleUsersPage"

export default function AdminUsersPage() {
  return <StaffRoleUsersPage role="admin" title="Admin Users" />
}
